import { connect } from 'react-redux';
import { getFormValues, reduxForm } from 'redux-form';
import { compose } from 'recompose';
import { getBarberUserId, getIsRentalBarber, getShopBrand, isBrandViewActive } from '../../../../auth/selectors';
import * as brandsSelectors from '../../../brands/selectors';
import * as categoriesSelectors from '../../../categories/selectors';
import * as taxSelectors from '../../../../main/settings/taxes/selectors';

import { PRODUCT_FORM_NAME, validateProductForm } from './formConfig';

const mapStateToProps = (state, props) => {
  const isRentalBarber = getIsRentalBarber(state);
  const isOwnerRentalBarber = isRentalBarber &&
    props.product.createdBy === 'barber' &&
    getBarberUserId(state) === props.product.createdById;

  const shopBrand = getShopBrand(state);

  const isNoBrandOrSingleShopBrand = !shopBrand || shopBrand.shopCount === 1;
  const isLimitedEditAccess = props.roleIdType.type === 'shop'
    ? !isNoBrandOrSingleShopBrand && props.isEditing
    : !isBrandViewActive(state) && !isOwnerRentalBarber && props.isEditing;

  return {
    shop: state.auth.shop,
    barberUser: state.auth.barberUser,
    brands: brandsSelectors.getAll(state),
    categories: categoriesSelectors.getAll(state),
    taxes: taxSelectors.enabled(state),
    isBrandUser: isBrandViewActive(state),
    isLimitedEditAccess,
    formValues: getFormValues(PRODUCT_FORM_NAME)(state),
  };
};

export default compose(
  reduxForm({
    form: PRODUCT_FORM_NAME,
    validate: validateProductForm,
  }),
  connect(mapStateToProps, null),
);
